export const PortfolioBidStrategy = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Bid Strategy',
    },
    Name: {
      'bulk-upload-header': 'Bid Strategy Name',
    },
    Type: {
      'bulk-upload-header': 'Bid Strategy Type',
    },
    Scope: {
      'bulk-upload-header': 'Bid Strategy Scope',
    },
    ReportingTimeZone: {
      'bulk-upload-header': 'Time Zone',
    },
    MaxCpc: {
      'bulk-upload-header': 'Bid Strategy MaxCpc',
      'bulk-upload-mapper': function (value) {
        return value ? value.Amount : undefined;
      },
    },
    TargetCpa: {
      'bulk-upload-header': 'Bid Strategy TargetCpa',
    },
    TargetRoas: {
      'bulk-upload-header': 'Bid Strategy TargetRoas',
    },
    TargetAdPosition: {
      'bulk-upload-header': 'Bid Strategy TargetAdPosition',
    },
    TargetImpressionShare: {
      'bulk-upload-header': 'Bid Strategy TargetImpressionShare',
    },
    CampaignType: {
      'bulk-upload-header': 'Campaign Type',
    },
  },
};
